export default "__VITE_ASSET__DCw7_UwH__"